<template>
  <div>
    <v-dialog v-model="dialog" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          x-small
          class="ma-2"
          text
          icon
          :color="isIO ? 'primary' : 'secondblue'"
        >
          <v-icon v-if="isIO" style="font-size: 20px !important;">
            info
          </v-icon>
          <v-icon v-else small>
            mdi-square-edit-outline
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="submitReview" class="pa-0">
            <v-card-title class="primary white--text">
              <span> {{ isIO ? 'Details' : 'Notes' }} </span>
            </v-card-title>
            <v-card-text>
              <v-container class="px-0">
                <v-col v-if="isIO" cols="12" class="pa-0">
                  <v-row class="px-2">
                    <v-icon color="primary" class="pt-0 bg-info"
                      >description</v-icon
                    >
                    <span
                      class="pl-2 font-weight-medium subtitle-1 darkblue--text"
                      >Supporting Documents Details</span
                    >
                  </v-row>
                  <v-col cols="12" class="pa-0 pt-2">
                    <v-simple-table
                      class="spending-table mb-3 nav-table"
                      id="convertedTable"
                    >
                      <template v-slot:default>
                        <thead>
                          <tr class="primary">
                            <th
                              class="f-14 white--text text-center"
                              width="30%"
                            >
                              Name
                            </th>
                            <th
                              class="f-14 white--text text-center"
                              width="50%"
                            >
                              File
                            </th>
                            <th class="f-14 white--text text-center">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <v-perfect-scroll
                          class="drawer-table--scroll"
                          :settings="scrollSettingsNotes"
                        >
                          <tbody>
                            <tr
                              v-if="
                                itemsDocs === undefined || itemsDocs.length == 0
                              "
                            >
                              <td
                                colspan="3"
                                class="text-center textlightgrey--text"
                              >
                                No data displayed
                              </td>
                            </tr>
                            <tr v-else v-for="item in itemsDocs" :key="item.id">
                              <td class="f-14 black--text" width="30%">
                                {{ '-' }}
                              </td>
                              <td width="50%">
                                {{ item.file ? item.file : '-' }}
                              </td>
                              <td class="text-center">
                                <v-btn
                                  x-small
                                  class="ma-2"
                                  fab
                                  dark
                                  color="secondblue"
                                  @click="downloadFile(item.file)"
                                >
                                  <v-icon x-small>
                                    mdi-cloud-download
                                  </v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </v-perfect-scroll>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-row class="px-2">
                    <hr class="hr-line" style="" />
                    <v-icon color="primary" class="pt-0 bg-info"
                      >error_outline</v-icon
                    >
                    <span
                      class="pl-2 pt-1 font-weight-medium subtitle-1 darkblue--text"
                      >Rejected Reason</span
                    >
                  </v-row>
                  <!-- <p class="mt-3">
                    <b>Notes:</b>
                  </p> -->
                  <v-textarea
                    label="Type your reason here"
                    single-line
                    class="mt-2"
                    outlined
                    v-model="notes"
                    :disabled="page !== 'approval' ? true : false"
                  ></v-textarea>
                </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions class="pr-4 pb-5">
              <v-spacer></v-spacer>
              <v-btn color="#bd1e19" dark @click="close()">
                Cancel
              </v-btn>
              <v-btn color="primary" type="submit" v-if="page == 'approval'">
                Submit
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ACLMixin from '../../mixins/ACLMixin';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import Swal from 'sweetalert2';
import ProgressDialog from '../progress_dialog';

export default {
  data() {
    return {
      progressDialogLoading: false,
      dialog: false,
      scrollSettingsNotes: {
        maxScrollbarLength: 150
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      itemNotes: {},
      notes: '',
      itemsDocs: []
    };
  },
  components: {
    'progress-dialog': ProgressDialog
  },
  mixins: [ACLMixin, LoginAsMixin],
  props: {
    isIO: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    },
    listGroup: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    page: {
      type: String,
      default: ''
    }
  },
  watch: {
    item(val) {
      this.itemNotes = val;
      this.notes = this.type === 'io' ? val.notes : '';
    },
    dialog(val) {
      if (val && this.isIO) {
        this.getSupportDocs();
      }
    }
  },
  mounted() {
    this.itemNotes = this.item;
    this.notes = this.type === 'io' ? this.item.notes : '';
  },
  methods: {
    close() {
      this.dialog = false;
    },
    submitReview() {
      const validated = this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        this.dialog = false;
        let payload = {};
        if (this.type === 'io') {
          payload = {
            type: this.type,
            spending_id: this.itemNotes.id,
            notes: this.notes
          };
        } else if (this.type === 'Budget Owner') {
          payload = {
            type: 'bo',
            bo_id: this.itemNotes.id,
            notes: this.notes
          };
        } else if (this.listGroup.level === 100 && this.type === 'House') {
          payload = {
            type: 'house',
            house_id: this.itemNotes.house_id,
            division_id: this.itemNotes.division_id,
            notes: this.notes
          };
        } else {
          payload = {
            type: 'group',
            group_id: this.itemNotes.id,
            notes: this.notes
          };
        }
        console.log('payload', payload);
        this.$store
          .dispatch('approval/updateNotes', payload)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              if (this.type === 'io') {
                this.itemNotes.notes = this.notes;
              } else {
                this.itemNotes.status = true;
              }
              Swal.fire('Success!', data.message.text_en, 'success');
              requestAnimationFrame(() => {
                this.$refs.obs.reset();
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            this.dialog = false;
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          });
      }
    },
    getSupportDocs() {
      this.progressDialogLoading = false;
      const params = {
        io_code: this.item.code
      };
      this.$store
        .dispatch('spending/editSupportDocs', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.itemsDocs = data.data.result;
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          if (err.response) {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          } else {
            Swal.fire('Failed!', 'Please try again', 'error');
          }
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    downloadFile(value) {
      let file = encodeURIComponent(value);
      window.open(
        this.baseUrl +
          '/v1/download/file?name=' +
          file +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>
